import { CheckCircle2, CircleDot, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const PlacePanel = ({ lab, placements, setPlacements, sel, setSel, why }) => {
  const { L, lang } = useLang();
  const nm = (o) => (lang === "hi" ? o.hi : o.en);
  const ids = Object.keys(lab.devices);
  const done = ids.filter((d) => placements[d]).length;
  return (
    <div data-testid="lab-place-panel">
      <p className="text-sm text-slate-600">{L("Pick a device, then tap a blue point in the room (or choose a spot below). Think about where each one works best.", "एक डिवाइस चुनिए, फिर कमरे में नीला पॉइंट tap कीजिए (या नीचे से जगह चुनिए)। सोचिए हर डिवाइस कहाँ सबसे अच्छा काम करेगा।")}</p>
      <div className="mt-2 text-xs font-bold text-[#0F766E]" data-testid="lab-place-count">{done}/{ids.length} {L("placed", "लगाए गए")}</div>
      <div className="mt-3 grid gap-2">
        {ids.map((d) => {
          const dev = lab.devices[d];
          const active = sel === d;
          return (
            <div key={d} className={`rounded-xl border-2 transition-colors ${active ? "border-[#0F766E] bg-[#F0FDFA]" : "border-slate-200 bg-white"}`}>
              <button type="button" onClick={() => setSel(active ? null : d)} className="w-full text-left px-3 py-2.5 flex items-center gap-3" data-testid={`lab-device-${d}`}>
                <span className="w-3 h-3 rounded-full border border-slate-300 shrink-0" style={{ background: dev.color }} />
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-bold text-[#0B1F3A]">{nm(dev)}</span>
                  <span className="block text-[11px] text-slate-500 truncate">{placements[d] ? nm(lab.spots[placements[d]]) : L("Not placed yet", "अभी नहीं लगाया")} · {dev.kind === "sensor" ? L("sensor", "सेंसर") : L("actuator", "एक्चुएटर")}</span>
                </span>
                {placements[d] ? <CheckCircle2 className="w-4 h-4 text-[#059669]" /> : <CircleDot className="w-4 h-4 text-slate-300" />}
              </button>
              {why?.[d] && <p className="px-3 pb-2 text-[11px] font-semibold text-[#B45309]" data-testid={`lab-why-${d}`}>{lang === "hi" ? why[d][1] : why[d][0]}</p>}
              {active && (
                <div className="px-3 pb-3 grid grid-cols-2 gap-1.5">
                  {Object.entries(lab.spots).map(([k, s]) => (
                    <button key={k} type="button" onClick={() => { setPlacements({ ...placements, [d]: k }); setSel(null); }}
                      className={`text-left rounded-lg border px-2 py-1.5 text-[11px] font-semibold inline-flex items-start gap-1 ${placements[d] === k ? "border-[#059669] bg-[#ECFDF5]" : "border-slate-200 bg-white hover:border-[#14B8A6]"}`} data-testid={`lab-spot-${d}-${k}`}>
                      <MapPin className="w-3 h-3 mt-0.5 shrink-0 text-[#0EA5E9]" />{nm(s)}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
